import { Button, OverlayTrigger, Tooltip } from '@valid-eval/shared-react-components';

interface CompareButtonProps {
  onCompare: (selectedRows: any[]) => void;
  selectedRows: any[];
}

function CompareButton({ onCompare, selectedRows }: CompareButtonProps) {
  const selectionCount = selectedRows.length;
  const canCompare = [2, 3].includes(selectionCount);
  const handleCompare = () => onCompare(selectedRows);

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={!canCompare ? <Tooltip>Can compare up to 3 teams</Tooltip> : <></>}
    >
      <Button
        variant={'primary'}
        style={{ pointerEvents: 'all', cursor: !canCompare ? 'not-allowed' : 'pointer' }}
        disabled={!canCompare}
        onClick={handleCompare}
        data-test-id="compare-teams-button"
      >
        Compare
      </Button>
    </OverlayTrigger>
  );
}

export default CompareButton;
